import type { SxProps, Theme } from "@mui/material"

const styles: Record<string, SxProps<Theme>> = {
  select: { minWidth: 150 },
  clearButton: { whiteSpace: "nowrap", textTransform: "none" }
}

export default styles
